import type { OnDemandItem} from "@ca.vmedia.tv/domains";
import { OnDemandCardData } from "@/components/Cards/types";
import { useFavoriteOnDemandsStore } from "@/stores/FavoritesOnDemand";
import { Logger } from '@/utils';
import type { AxiosError } from 'axios';
import type { ExposeInterface } from './types';

export const useShowAllMyTvOnDemandStore = defineStore('ShowAllMyTvOnDemand', (): ExposeInterface => {
    const FavoriteOnDemandsStore = useFavoriteOnDemandsStore();
    const {
        getFavoriteOnDemands
    } = storeToRefs(FavoriteOnDemandsStore);

    const { fetchFavoriteOnDemands, fetchFavoriteOnDemandsNextPage, clearSoft } = FavoriteOnDemandsStore;


    const _favoritesOnDemandItems = computed((): OnDemandItem[] => getFavoriteOnDemands.value?.items ?? []);
    const getCardsOnDemand = computed((): OnDemandCardData[] => _favoritesOnDemandItems.value.map((item) => new OnDemandCardData(item)));

    const _isFavoritesOnDemandLoading: Ref<boolean> = ref(false);
    const getIsFavoritesOnDemandLoading = computed((): boolean => _isFavoritesOnDemandLoading.value);

    const loadFavoritesOnDemand = async (): Promise<void> => {
        try {
            _isFavoritesOnDemandLoading.value = true;
            await fetchFavoriteOnDemands();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesOnDemandLoading.value = false;
        }
    };
    const loadFavoritesOnDemandNextPage = async (): Promise<void> => {
        if(_isFavoritesOnDemandLoading.value === true
            || !getFavoriteOnDemands.value?.paging?.pageNumber
            || !getFavoriteOnDemands.value?.paging?.totalPages
            || (getFavoriteOnDemands.value.paging.pageNumber >= getFavoriteOnDemands.value.paging.totalPages)){
            return;
        }

        try {
            _isFavoritesOnDemandLoading.value = true;
            await fetchFavoriteOnDemandsNextPage();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        } finally {
            _isFavoritesOnDemandLoading.value = false;
        }
    };

    const clearAll = (): void => {
        clearSoft();
    };


    return {
        getCardsOnDemand,
        getIsFavoritesOnDemandLoading,
        loadFavoritesOnDemand,
        loadFavoritesOnDemandNextPage,
        clearAll
    };
});
